import DecoratedLink from '@js/DecoratedLink'
import Toast from '@js/Toast'

/**
 * Searches for href="mailto:" links and adds screen-reader and a button to copy
 * the email address to the user's clipboard.
 *
 * @extends DecoratedLink
 */
class MailtoLink extends DecoratedLink {
    constructor(element) {
        super(element, {
            srMessage: 'interact to open a new email draft'
        })

        if (sir.isEditor) return

        if (!('clipboard' in navigator)) return

        this.element = element

        const copyButton = document.createElement('button')
        copyButton.classList.add('jello-link')

        const copyIcon = document.createElement('i')
        copyIcon.classList.add('decorated-link-icon')
        copyIcon.classList.add('fa-clone')
        copyIcon.classList.add('fa-solid')
        copyIcon.ariaHidden = true
        copyButton.append(copyIcon)

        const copySrMessage = document.createElement('span')
        copySrMessage.classList.add('sr-only')
        copySrMessage.innerHTML = 'copy email address to clipboard'
        copyButton.append(copySrMessage)
        element.after(copyButton)
        element.after(document.createTextNode('\xa0'))

        copyButton.addEventListener('click', this.copyEmailAddress)
    }

    /**
     * Copies the email address to the user's clipboard and presents a Toast
     * @returns {Promise}
     */
    copyEmailAddress = async () => {
        try {
            const address = this.element.href.replace(/^mailto:/, '')
            await navigator.clipboard.writeText(address)
            new Toast(`&lt;<strong>${address}</strong>&gt; copied to clipboard.`)
        } catch (error) {
            new Toast('Sorry! We failed to copy the address to your clipboard.')
            console.error(error.message)
        }
    }
}

MailtoLink.create('a[href^="mailto:"]')
